import { z } from 'zod'

// Helper functions for validation
const mobileRegex = /^[0-9]{1,10}$/ // Mobile should be a number of 1 to 10 digits
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/ // Basic email validation regex
const businessPhoneRegex = /^[0-9]{1,10}$/ // Business phone should not be more than 10 digits

export const integratorValidation = z.object({
  name: z.string().min(1, { message: 'Integrator name must not be blank' }).max(50, { message: 'Integrator name must not be longer than 50 characters' }),
  desp: z.string().max(255, { message: 'Description must not be longer than 255 characters' }).optional(),
  remarks: z.string().max(255, { message: 'Remarks must not be longer than 255 characters' }).optional(),
  divisionId: z.string().min(1, { message: 'Division must not be blank' }),
  clientId: z.string().min(1, { message: 'Client must not be blank' }).optional(),
  address: z.object({
    line1: z.string().min(1, { message: 'Address Line 1 must not be blank' }).max(50, { message: 'Address line 1 must not be longer than 50 characters' }).optional(),
    line2: z.string().max(50, { message: 'Address Line 2 must not be longer than 50 characters' }).optional(),
    line3: z.string().max(50, { message: 'Address Line 3 must not be longer than 50 characters' }).optional(),
    countryId: z.string().min(1, { message: 'Country must not be blank' }).optional(),
    type: z.string().min(1, { message: 'Type must not be blank' }).optional(),
    postcode: z.string().min(1, { message: 'Post code must not be blank' }).max(12, { message: 'Post code must not be longer than 12 characters' }).optional(),
    state: z.string().min(1, { message: 'State must not be blank' }).max(50, { message: 'State must not be longer than 50 characters' }).optional(),
    city: z.string().min(1, { message: 'City must not be blank' }).max(30, { message: 'City must not be longer than 30 characters' }).optional(),
  }).nullable().optional(),
  personsInCharge: z.array(z.object({
    firstName: z.string().min(1, { message: 'First name must not be blank' }).max(50, { message: 'First name must not be longer than 50 characters' }),
    lastName: z.string().max(50, { message: 'Last name must not be longer than 50 characters' }),
    contacts: z.array(z.object({
      contactVal: z.string().min(1, { message: 'Contact must not be blank' }).max(30, { message: 'Contact must not be longer than 30 characters' }),
      contactLocalVal: z.string().optional(),
      type: z.string().min(1, { message: 'Contact type must not be blank' }),
    }).superRefine((data, ctx) => {
      // Conditional validation based on the type
      if (data.type === 'MOBILE' && ((data.contactLocalVal && !mobileRegex.test(data.contactLocalVal)) ?? (!data.contactVal && data.contactLocalVal === undefined))) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Invalid mobile number. It should not more then 10 digits.',
          path: ['contactVal'],
        })
      }
      else if (data.type === 'EMAIL' && !emailRegex.test(data.contactVal)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Invalid email address.',
          path: ['contactVal'],
        })
      }
      else if (data.type === 'BUSINESS_PHONE' && ((data.contactLocalVal && !businessPhoneRegex.test(data.contactLocalVal)) ?? (!data.contactVal && data.contactLocalVal === undefined))) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Invalid business phone number. It should not more then 10 digits.',
          path: ['contactVal'],
        })
      }
    })).optional(),
  })).optional(),
  contacts: z.array(z.object({
    contactVal: z.string().min(1, { message: 'Contact must not be blank' }).max(30, { message: 'Contact must not be longer than 30 characters' }),
    contactLocalVal: z.string().optional(),
    type: z.string().min(1, { message: 'Contact type must not be blank' }),
  }).superRefine((data, ctx) => {
    // Conditional validation based on the type
    if (data.type === 'MOBILE' && ((data.contactLocalVal && !mobileRegex.test(data.contactLocalVal)) ?? (!data.contactVal && data.contactLocalVal === undefined))) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Invalid mobile number. It should not more then 10 digits.',
        path: ['contactVal'],
      })
    }
    else if (data.type === 'EMAIL' && !emailRegex.test(data.contactVal)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Invalid email address.',
        path: ['contactVal'],
      })
    }
    else if (data.type === 'BUSINESS_PHONE' && ((data.contactLocalVal && !businessPhoneRegex.test(data.contactLocalVal)) ?? (!data.contactVal && data.contactLocalVal === undefined))) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Invalid business phone number. It should not more then 10 digits.',
        path: ['contactVal'],
      })
    }
  })).optional(),
})
